// extracted by mini-css-extract-plugin
module.exports = {"returnsAndExchanges":"zx","ups":"Ax","boxes":"Bx","illustration":"Cx"};